export function Field({ type = "text", id, name, label, required = false, className = "", ...rest }) {
  return (
    <div className={`relative ${className}`}>
      <input
        type={type}
        id={id}
        name={name}
        required={required}
        placeholder=" "
        className="field peer"
        {...rest}
      />
      <label htmlFor={id} className="field-label absolute">
        {label}
        {required && <span className="text-gold-500"> *</span>}
      </label>
    </div>
  );
}

export function TextareaField({ id, name, label, required = false, rows = 5, className = "", ...rest }) {
  return (
    <div className={`relative ${className}`}>
      <textarea
        id={id}
        name={name}
        required={required}
        placeholder=" "
        rows={rows}
        className="field peer resize-none"
        {...rest}
      />
      <label htmlFor={id} className="field-label absolute">
        {label}
        {required && <span className="text-gold-500"> *</span>}
      </label>
    </div>
  );
}

export function SelectField({ id, name, label, required = false, options, className = "", ...rest }) {
  return (
    <div className={className}>
      <label htmlFor={id} className="mb-2 block text-sm text-stone-400">
        {label}
        {required && <span className="text-gold-500"> *</span>}
      </label>
      <select id={id} name={name} required={required} defaultValue="" className="field" {...rest}>
        <option value="" disabled>
          Sélectionnez une option
        </option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
